import { constantTree } from "../../../core/events/ConstantTree";

export const myAccountTree = constantTree({
    exitStep: "",
    unregisterAllEvents: "",
    MyAccount: {
        SignOut: {
            Click: ""
        },
        Init: "",
        Action: {
            Click: ""
        },
    },
    Settings: {
        Initialize: "",
        SendPasswordResetLink: "",
        SaveNotificationPreferences: "",
        DeleteAccount: "",
    },
    PersonalInformation: {
        MobileCountryCode: {
            Click: "",
            Change: ""
        },
        InvoiceDetails: {
            Toggle: ""
        },
        Form: {
            Modified: "",
            Validation: "",
            Initialize: "",
            Save: "",
        },
        PhoneNumber: {
            Change: ""
        },
        Percentage: {
            Change: ""
        },
        OTP: {
            Verify: {
                Click: "",
                SendCode: ""
            },
            Reset: ""
        }
    },
    personalizeExperience: {
        TabChange: "",
        General: {
            Form: {
                Save: "",
            }
        },
        Widgets: {
            DragAndDrop: "",
            FetchWidgets: "",
            FavoriteTripsForToday: {
                Save: "",
                UpdateFieldValue: "",
                SetFieldsToAtom: "",
            },
            FavoriteDepartures: {
                Save: "",
                UpdateFieldValue: "",
                SetFieldsToAtom: "",
            },
        }
    },
    companionSetting: {
        form: {
            Init: "",
            Add: "",
            Update: "",
            Delete: '',
        }
    },
    paymentCards: {
        Get: "",
        Delete: "",
        Vouchers: {
            Get: "",
            Details: "",
            Add: ""
        }
    },
    loyaltyProgram: {
        get: "",
        tiers: "",
        joinLoyaltyProgram: "",
        seeMore: "",
        aboutLoyaltyProgram: ""
    }
})
